/* WearingTime Luxe Theme — JavaScript */

/* Header height measurement — standalone and FIRST, so an error elsewhere in the
   main script can never stop it. Feeds the real rendered header + announcement
   height into --header-total / --announcement-h so fixed-header clearance below
   the header (breadcrumb, page tops) is always correct, even when the logo or
   announcement wraps to extra lines on mobile. */
(function () {
  function measureHeader() {
    const header = document.getElementById('site-header');
    if (!header) return;
    const announcement = document.querySelector('.announcement-bar');
    const annH = announcement ? announcement.offsetHeight : 0;
    const total = header.offsetHeight + annH;
    document.documentElement.style.setProperty('--announcement-h', annH + 'px');
    if (total > 0) document.documentElement.style.setProperty('--header-total', total + 'px');
  }
  measureHeader();
  document.addEventListener('DOMContentLoaded', measureHeader);
  window.addEventListener('load', measureHeader);
  window.addEventListener('resize', measureHeader);
  if ('ResizeObserver' in window) {
    const obs = new ResizeObserver(measureHeader);
    const h = document.getElementById('site-header');
    const a = document.querySelector('.announcement-bar');
    if (h) obs.observe(h);
    if (a) obs.observe(a);
  }
})();

(function () {
  'use strict';

  /* ============================================================
     Theme Toggle (dark / light)
  ============================================================ */
  const themeToggleBtn = document.getElementById('theme-toggle');
  const mobileModeBtn = document.getElementById('mobile-theme-toggle');
  const body = document.body;

  function syncModeLabel() {
    const current = body.getAttribute('data-theme') === 'light' ? 'Light' : 'Dark';
    document.querySelectorAll('[data-mode-label]').forEach(el => { el.textContent = current; });
  }
  function setTheme(theme) {
    body.setAttribute('data-theme', theme);
    localStorage.setItem('wt-theme', theme);
    syncModeLabel();
  }
  function toggleTheme() {
    setTheme(body.getAttribute('data-theme') === 'dark' ? 'light' : 'dark');
  }

  (function initTheme() {
    const fallback = body.getAttribute('data-default-theme') || 'dark';
    const saved = localStorage.getItem('wt-theme') || fallback;
    setTheme(saved);
  })();

  if (themeToggleBtn) themeToggleBtn.addEventListener('click', toggleTheme);
  if (mobileModeBtn) mobileModeBtn.addEventListener('click', toggleTheme);

  /* ============================================================
     Mobile Menu
  ============================================================ */
  const mobileMenu = document.getElementById('mobile-menu');
  const menuToggles = document.querySelectorAll('[data-menu-toggle]');

  if (mobileMenu && menuToggles.length) {
    function setMenu(open) {
      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
      menuToggles.forEach(b => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
      document.body.style.overflow = open ? 'hidden' : '';
    }
    menuToggles.forEach(btn => {
      btn.addEventListener('click', () => setMenu(!mobileMenu.classList.contains('is-open')));
    });
    // Close on scrim, close (X) button, or any link click
    mobileMenu.querySelectorAll('[data-close-menu]').forEach(el => el.addEventListener('click', () => setMenu(false)));
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
    // Escape closes
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) setMenu(false);
    });
    // Collapsible submenus (chevron rows)
    mobileMenu.querySelectorAll('[data-submenu-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.mobile-menu__item');
        const expanded = item.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }

  /* ============================================================
     Drawers
  ============================================================ */
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-drawer]').forEach(btn => {
    btn.addEventListener('click', () => openDrawer(btn.dataset.openDrawer));
  });

  document.querySelectorAll('[data-close-drawer]').forEach(el => {
    el.addEventListener('click', function () {
      closeDrawer(this.closest('.drawer'));
    });
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer[aria-hidden="false"]').forEach(closeDrawer);
    }
  });

  /* ============================================================
     Sticky Header
  ============================================================ */
  const header = document.getElementById('site-header');
  const stickyMode = header ? (header.dataset.sticky || 'always') : 'always';
  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const current = window.scrollY;
    if (header) {
      header.classList.toggle('site-header--scrolled', current > 40);
      // "On scroll up": hide the header (and announcement) when scrolling down,
      // reveal them when scrolling back up.
      if (stickyMode === 'scroll-up') {
        if (current > lastScroll && current > 200) {
          document.body.classList.add('header-hidden');
        } else if (current < lastScroll - 4 || current <= 80) {
          document.body.classList.remove('header-hidden');
        }
      }
    }
    lastScroll = current <= 0 ? 0 : current;
  }, { passive: true });

  /* ============================================================
     Filter Group Toggles (sidebar)
  ============================================================ */
  document.querySelectorAll('.filter-group__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      const list = btn.nextElementSibling;
      if (list) list.classList.toggle('filter-group__list--collapsed', expanded);
    });
  });

  // Keep any filter group with an active selection expanded after reload
  document.querySelectorAll('.filter-group').forEach(group => {
    if (group.querySelector('input[type="checkbox"]:checked')) {
      const toggle = group.querySelector('.filter-group__toggle');
      const list = group.querySelector('.filter-group__list');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (list) list.classList.remove('filter-group__list--collapsed');
    }
  });

  // Mobile filter drawer
  (function filterDrawer() {
    const sidebar = document.getElementById('collection-sidebar');
    const overlay = document.getElementById('filters-overlay');
    const openBtn = document.getElementById('open-filters');
    const closeBtn = document.getElementById('close-filters');
    if (!sidebar || !overlay) return;
    function open() { sidebar.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { sidebar.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  })();

  /* ============================================================
     Collection Sidebar Filters — tag-based URL navigation
  ============================================================ */
  const filterCheckboxes = document.querySelectorAll('.filter-group__list input[type="checkbox"]');
  const clearBtn = document.getElementById('clear-all-filters');

  // The canonical collection URL (no tag segment), e.g. /collections/all
  function collectionBase() {
    if (clearBtn) {
      const href = clearBtn.getAttribute('href');
      if (href) return href.split('?')[0];
    }
    const parts = window.location.pathname.split('/').filter(Boolean);
    const i = parts.indexOf('collections');
    return (i !== -1 && parts[i + 1]) ? '/' + parts[i] + '/' + parts[i + 1] : window.location.pathname;
  }

  filterCheckboxes.forEach(cb => {
    cb.addEventListener('change', () => {
      // Single-select within a group: tag filtering is AND-only, so two options
      // in the same facet (e.g. two price ranges) can never match — uncheck siblings.
      if (cb.checked) {
        const group = cb.closest('.filter-group');
        if (group) {
          group.querySelectorAll('input[type="checkbox"]').forEach(other => {
            if (other !== cb) other.checked = false;
          });
        }
      }
      applyFilters();
    });
  });

  function applyFilters() {
    const checked = Array.from(filterCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.dataset.tag);
    const base = collectionBase();
    window.location.href = checked.length ? base + '/' + checked.join('+') : base;
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', e => {
      e.preventDefault();
      filterCheckboxes.forEach(cb => { cb.checked = false; });
      window.location.href = collectionBase();
    });
  }

  /* ============================================================
     Collection Search (client-side filter)
  ============================================================ */
  const searchInput = document.getElementById('collection-search-input');
  const productGrid = document.getElementById('product-grid');

  if (searchInput && productGrid) {
    // Live search across the WHOLE catalog. Typing renders Shopify search results
    // straight into the grid, so results are not limited to the current page.
    const fullSearch = q => {
      window.location.href = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
    };

    const originalGrid = productGrid.innerHTML;
    const countEl = document.querySelector('.collection-count');
    const originalCount = countEl ? countEl.innerHTML : '';

    let hint = document.getElementById('collection-search-hint');
    if (!hint) {
      hint = document.createElement('button');
      hint.type = 'button';
      hint.id = 'collection-search-hint';
      hint.className = 'collection-search__hint';
      hint.hidden = true;
      searchInput.parentNode.appendChild(hint);
      hint.addEventListener('click', () => fullSearch(searchInput.value.trim()));
    }

    const restore = () => {
      productGrid.innerHTML = originalGrid;
      if (countEl) countEl.innerHTML = originalCount;
      hint.hidden = true;
      productGrid.classList.remove('is-searching');
    };

    let debounceId, inflight, lastQuery = '';

    const runSearch = query => {
      if (inflight) inflight.abort();
      inflight = typeof AbortController !== 'undefined' ? new AbortController() : null;
      productGrid.classList.add('is-searching');

      const url = '/search?type=product&options%5Bprefix%5D=last&q=' +
                  encodeURIComponent(query) + '&section_id=main-search';

      fetch(url, inflight ? { signal: inflight.signal } : undefined)
        .then(r => (r.ok ? r.text() : Promise.reject(r.status)))
        .then(html => {
          if (searchInput.value.trim() !== query) return; // a newer keystroke won
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const cards = Array.prototype.slice.call(doc.querySelectorAll('.product-card'));

          // In-stock first, otherwise keep Shopify's relevance order.
          cards.sort((a, b) =>
            (b.dataset.available === 'true') - (a.dataset.available === 'true'));

          productGrid.classList.remove('is-searching');
          if (!cards.length) {
            productGrid.innerHTML =
              '<p class="col-full collection-search__empty">No watches match "' +
              query.replace(/[<>&]/g, '') + '".</p>';
          } else {
            productGrid.innerHTML = '';
            cards.forEach(c => productGrid.appendChild(c));
          }
          if (countEl) {
            countEl.innerHTML = 'Showing <strong>' + cards.length + '</strong> result' +
              (cards.length === 1 ? '' : 's');
          }
          hint.hidden = false;
          hint.textContent = 'Press Enter to open the full search page';
        })
        .catch(err => {
          if (err && err.name === 'AbortError') return;
          productGrid.classList.remove('is-searching');
          hint.hidden = false;
          hint.textContent = 'Press Enter to search all watches';
        });
    };

    searchInput.addEventListener('input', () => {
      const query = searchInput.value.trim();
      if (query === lastQuery) return;
      lastQuery = query;
      clearTimeout(debounceId);

      if (!query) {
        if (inflight) inflight.abort();
        restore();
        return;
      }
      // Wait for a pause in typing so we are not firing a request per keystroke.
      debounceId = setTimeout(() => runSearch(query), 250);
    });

    searchInput.addEventListener('keydown', e => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      const q = searchInput.value.trim();
      if (q) fullSearch(q);
    });
  }

  /* ============================================================
     Sort Select
  ============================================================ */
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ============================================================
     Product Gallery — thumbnails, lightbox, hover zoom
  ============================================================ */
  (function productGallery() {
    const gallery = document.querySelector('[data-gallery]');
    const galleryMain = document.getElementById('gallery-main-img');
    if (!galleryMain) return;

    let currentIndex = 0;
    const thumbs = Array.from(document.querySelectorAll('.gallery-thumb'));

    // Warm the browser cache for full-size images so switching is instant.
    const preloaded = new Set();
    function preload(url) {
      if (!url || preloaded.has(url)) return;
      preloaded.add(url);
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
    }
    function preloadAround(i) {
      if (!thumbs.length) return;
      const n = thumbs.length;
      [i, i + 1, i - 1].forEach(k => {
        const t = thumbs[(k + n) % n];
        if (t) preload(t.dataset.full);
      });
    }

    function setMain(index) {
      if (!thumbs.length) return;
      const i = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[i];
      galleryMain.src = thumb.dataset.full;
      galleryMain.dataset.zoomSrc = thumb.dataset.zoomSrc || thumb.dataset.full;
      currentIndex = i;
      galleryMain.dataset.index = i;
      thumbs.forEach(t => t.classList.remove('gallery-thumb--active'));
      thumb.classList.add('gallery-thumb--active');
      preloadAround(i); // get the neighbours ready for the next click
    }

    // Thumbnail switching — preload on hover so the click is instant
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => setMain(parseInt(thumb.dataset.index, 10) || 0));
      thumb.addEventListener('mouseenter', () => preload(thumb.dataset.full), { passive: true });
    });

    // Prev / next arrows on the main image
    const galleryPrev = document.querySelector('[data-gallery-prev]');
    const galleryNext = document.querySelector('[data-gallery-next]');
    if (galleryPrev) galleryPrev.addEventListener('click', e => { e.stopPropagation(); setMain(currentIndex - 1); });
    if (galleryNext) galleryNext.addEventListener('click', e => { e.stopPropagation(); setMain(currentIndex + 1); });

    // Preload the first neighbours once the page is idle
    if ('requestIdleCallback' in window) { requestIdleCallback(() => preloadAround(0)); }
    else { setTimeout(() => preloadAround(0), 800); }

    /* ---- Hover-to-magnify (desktop) ---- */
    if (gallery && gallery.dataset.zoomEnabled === 'true') {
      const stage = document.getElementById('gallery-main');
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (stage && canHover) {
        // While the pointer is over a prev/next arrow, keep the image zoomed OUT
        // so you can see the next photo without having to move the mouse away first.
        let overArrow = false;
        const zoomOut = () => {
          galleryMain.style.transform = '';
          galleryMain.style.transformOrigin = 'center center';
        };
        stage.addEventListener('mousemove', e => {
          if (overArrow) { zoomOut(); return; }
          const r = stage.getBoundingClientRect();
          const x = ((e.clientX - r.left) / r.width) * 100;
          const y = ((e.clientY - r.top) / r.height) * 100;
          galleryMain.style.transform = 'scale(2.2)';
          galleryMain.style.transformOrigin = `${x}% ${y}%`;
        });
        stage.addEventListener('mouseleave', zoomOut);
        [galleryPrev, galleryNext].forEach(btn => {
          if (!btn) return;
          btn.addEventListener('mouseenter', () => { overArrow = true; zoomOut(); });
          btn.addEventListener('mouseleave', () => { overArrow = false; });
        });
      }
    }

    /* ---- Lightbox ---- */
    const lightbox = document.getElementById('lightbox');
    if (gallery && gallery.dataset.lightboxEnabled === 'true' && lightbox) {
      const lbImg = document.getElementById('lightbox-img');
      const lbCounter = document.getElementById('lightbox-counter');
      let images = [];
      try { images = JSON.parse(document.getElementById('gallery-images').textContent); } catch (e) {}

      function preloadLbAround(i) {
        const n = images.length;
        if (!n) return;
        preload(images[(i + 1) % n]);     // next
        preload(images[(i - 1 + n) % n]); // prev
      }
      function showImage(i) {
        if (!images.length) return;
        currentIndex = (i + images.length) % images.length;
        lbImg.src = images[currentIndex];
        if (lbCounter) lbCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
        preloadLbAround(currentIndex); // ready the neighbours so next/prev is instant
      }
      function openLightbox() {
        if (!images.length) return;
        showImage(currentIndex);
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      function closeLightbox() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      galleryMain.addEventListener('click', openLightbox);
      galleryMain.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(); } });
      lightbox.querySelectorAll('[data-lb-close]').forEach(el => el.addEventListener('click', closeLightbox));
      lightbox.querySelector('[data-lb-next]')?.addEventListener('click', () => showImage(currentIndex + 1));
      lightbox.querySelector('[data-lb-prev]')?.addEventListener('click', () => showImage(currentIndex - 1));
      lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });
      document.addEventListener('keydown', e => {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') showImage(currentIndex + 1);
        if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      });
    }
  })();

  /* ============================================================
     Wishlist (localStorage)
  ============================================================ */
  const WISHLIST_KEY = 'wt-wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function toggleWishlist(item) {
    const list = getWishlist();
    const idx = list.findIndex(i => i.id === item.id);
    if (idx > -1) { list.splice(idx, 1); }
    else { list.push(item); }
    saveWishlist(list);
    updateWishlistUI();
    return idx === -1; // true = added
  }

  function updateWishlistUI() {
    const list = getWishlist();
    const countEl = document.getElementById('wishlist-count');
    if (countEl) {
      countEl.textContent = list.length;
      countEl.style.display = list.length > 0 ? 'flex' : 'none';
    }

    // Mark active btns
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const id = parseInt(btn.dataset.productId);
      btn.classList.toggle('is-active', list.some(i => i.id === id));
    });

    // Render drawer
    const container = document.getElementById('wishlist-items');
    if (!container) return;
    if (list.length === 0) {
      container.innerHTML = '<p style="color:var(--color-muted);font-size:14px;">No saved pieces yet.</p>';
      return;
    }
    container.innerHTML = list.map(item => `
      <div class="wishlist-item">
        <img src="${item.image}" alt="${item.title}" loading="lazy">
        <div class="wishlist-item__info">
          <p class="wishlist-item__brand">${item.brand || ''}</p>
          <p class="wishlist-item__title"><a href="${item.url}">${item.title}</a></p>
          <p class="wishlist-item__price">${item.price}</p>
        </div>
        <button class="wishlist-item__remove" data-remove-id="${item.id}" aria-label="Remove">&times;</button>
      </div>
    `).join('');

    container.querySelectorAll('[data-remove-id]').forEach(btn => {
      btn.addEventListener('click', () => {
        const list2 = getWishlist().filter(i => i.id !== parseInt(btn.dataset.removeId));
        saveWishlist(list2);
        updateWishlistUI();
      });
    });
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    const item = {
      id: parseInt(btn.dataset.productId),
      title: btn.dataset.productTitle,
      price: btn.dataset.productPrice,
      image: btn.dataset.productImage || '',
      url: btn.dataset.productUrl,
      brand: btn.dataset.productBrand || ''
    };
    toggleWishlist(item);
  });

  updateWishlistUI();

  /* ============================================================
     Compare (localStorage, max 3)
  ============================================================ */
  const COMPARE_KEY = 'wt-compare';
  const MAX_COMPARE = 3;

  function getCompare() {
    try { return JSON.parse(localStorage.getItem(COMPARE_KEY)) || []; }
    catch { return []; }
  }

  function saveCompare(list) {
    localStorage.setItem(COMPARE_KEY, JSON.stringify(list));
  }

  function toggleCompare(item) {
    const list = getCompare();
    const idx = list.findIndex(i => i.id === item.id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      if (list.length >= MAX_COMPARE) {
        alert('You can compare up to ' + MAX_COMPARE + ' pieces at a time.');
        return false;
      }
      list.push(item);
    }
    saveCompare(list);
    updateCompareUI();
    return true;
  }

  function updateCompareUI() {
    const list = getCompare();
    const bar = document.getElementById('compare-bar');
    const count = document.getElementById('compare-count');
    const itemsEl = document.getElementById('compare-bar-items');

    if (bar) bar.classList.toggle('is-visible', list.length > 0);
    if (count) count.textContent = list.length;

    if (itemsEl) {
      itemsEl.innerHTML = list.map(item => `
        <div class="compare-bar__item">
          <img src="${item.image}" alt="${item.title}">
          <span>${item.title}</span>
          <button class="compare-bar__item-remove" data-remove-id="${item.id}" aria-label="Remove">&times;</button>
        </div>
      `).join('');
      itemsEl.querySelectorAll('[data-remove-id]').forEach(btn => {
        btn.addEventListener('click', () => {
          const l = getCompare().filter(i => i.id !== parseInt(btn.dataset.removeId));
          saveCompare(l);
          updateCompareUI();
          updateCompareBtns();
        });
      });
    }

    updateCompareBtns();
    renderComparePage();
  }

  function updateCompareBtns() {
    const list = getCompare();
    document.querySelectorAll('.compare-btn').forEach(btn => {
      btn.classList.toggle('is-active', list.some(i => i.id === parseInt(btn.dataset.productId)));
    });
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('.compare-btn');
    if (!btn) return;
    const item = {
      id: parseInt(btn.dataset.productId),
      title: btn.dataset.productTitle,
      price: btn.dataset.productPrice,
      image: btn.dataset.productImage || '',
      url: btn.dataset.productUrl,
      brand: btn.dataset.productBrand || '',
      ref: btn.dataset.productRef || '',
      material: btn.dataset.productMaterial || '',
      condition: btn.dataset.productCondition || ''
    };
    toggleCompare(item);
  });

  const compareClearBtn = document.getElementById('compare-clear-btn');
  if (compareClearBtn) {
    compareClearBtn.addEventListener('click', () => {
      saveCompare([]);
      updateCompareUI();
    });
  }

  const comparePageClear = document.getElementById('compare-page-clear');
  if (comparePageClear) {
    comparePageClear.addEventListener('click', () => {
      saveCompare([]);
      updateCompareUI();
    });
  }

  // Compare modal (opens from the compare bar — no separate page needed)
  const compareModal = document.getElementById('compare-modal');
  const compareGoBtn = document.getElementById('compare-go-btn');
  if (compareModal) {
    function openCompare() {
      renderComparePage();
      compareModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeCompare() {
      compareModal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (compareGoBtn) compareGoBtn.addEventListener('click', openCompare);
    compareModal.querySelectorAll('[data-close-compare]').forEach(el => el.addEventListener('click', closeCompare));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCompare(); });
  }

  /* ============================================================
     Compare Page rendering
  ============================================================ */
  function renderComparePage() {
    const wrap = document.getElementById('compare-table-wrap');
    const emptyMsg = document.getElementById('compare-empty-msg');
    const pageCount = document.getElementById('compare-page-count');
    if (!wrap) return;

    const list = getCompare();
    if (pageCount) pageCount.textContent = list.length;

    if (list.length === 0) {
      if (emptyMsg) emptyMsg.style.display = '';
      const table = wrap.querySelector('.compare-table');
      if (table) table.remove();
      return;
    }

    if (emptyMsg) emptyMsg.style.display = 'none';

    // Find cheapest price for "LOWEST" badge
    const prices = list.map(i => parseFloat(i.price.replace(/[^0-9.]/g, '')));
    const minPrice = Math.min(...prices);

    const rows = [
      { label: 'Price', key: 'price', render: (item, idx) => {
        const p = parseFloat(item.price.replace(/[^0-9.]/g, ''));
        return item.price + (p === minPrice && list.length > 1 ? ' <span class="compare-table__lowest">LOWEST</span>' : '');
      }},
      { label: 'Reference', key: 'ref' },
      { label: 'Brand', key: 'brand' },
      { label: 'Material', key: 'material' },
      { label: 'Condition', key: 'condition' }
    ];

    let html = `<div style="overflow-x:auto"><table class="compare-table"><thead><tr><th></th>`;
    list.forEach(item => {
      html += `<td>
        <button class="compare-table__remove" data-remove-id="${item.id}" aria-label="Remove">&times;</button>
        <img class="compare-table__img" src="${item.image}" alt="${item.title}">
        <p class="compare-table__brand">${item.brand}</p>
        <p class="compare-table__title"><a href="${item.url}">${item.title}</a></p>
      </td>`;
    });
    html += `</tr></thead><tbody>`;

    rows.forEach(row => {
      html += `<tr><th>${row.label}</th>`;
      list.forEach((item, idx) => {
        const val = row.render ? row.render(item, idx) : (item[row.key] || '—');
        html += `<td class="${row.key === 'price' ? 'compare-table__price' : ''}">${val}</td>`;
      });
      html += `</tr>`;
    });

    html += `</tbody></table></div>`;
    wrap.innerHTML = html + (emptyMsg ? emptyMsg.outerHTML : '');

    wrap.querySelectorAll('[data-remove-id]').forEach(btn => {
      btn.addEventListener('click', () => {
        const l = getCompare().filter(i => i.id !== parseInt(btn.dataset.removeId));
        saveCompare(l);
        updateCompareUI();
      });
    });
  }

  updateCompareUI();

  /* ============================================================
     Service card checkboxes (repairs form)
  ============================================================ */
  document.querySelectorAll('.service-card').forEach(card => {
    const input = card.querySelector('input[type="checkbox"]');
    if (!input) return;
    card.addEventListener('click', () => {
      input.checked = !input.checked;
      card.classList.toggle('is-selected', input.checked);
    });
  });

  /* ============================================================
     Variant pills (product page)
  ============================================================ */
  (function variantPicker() {
    const picker = document.getElementById('variant-picker');
    const dataEl = document.getElementById('variant-data');
    const idInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('product-price');
    const addBtn = document.getElementById('add-to-cart');
    if (!dataEl || !idInput) return;

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function selectedOptions() {
      const checked = picker ? picker.querySelectorAll('input[type="radio"]:checked') : [];
      return Array.from(checked).map(i => i.value);
    }

    function findVariant(opts) {
      return variants.find(v => v.options.every((o, idx) => o === opts[idx]));
    }

    function update() {
      const opts = selectedOptions();
      const variant = opts.length ? findVariant(opts) : variants[0];

      // active pill styling
      if (picker) {
        picker.querySelectorAll('.variant-pill').forEach(pill => {
          const input = pill.querySelector('input');
          pill.classList.toggle('variant-pill--active', input && input.checked);
        });
      }

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      idInput.value = variant.id;

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="price__was">' + money(variant.compare_at_price) + '</span>' +
            '<span class="price__now">' + money(variant.price) + '</span>';
        } else {
          priceEl.textContent = money(variant.price);
        }
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }
    }

    if (picker) {
      picker.addEventListener('change', update);
    }
  })();

  /* ============================================================
     Announcement bar carousel
  ============================================================ */
  document.querySelectorAll('[data-announcement]').forEach(bar => {
    const slides = Array.from(bar.querySelectorAll('.announcement-bar__slide'));
    if (slides.length <= 1) return;

    let index = slides.findIndex(s => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer = null;
    const autoplay = bar.dataset.autoplay === 'true';
    const interval = parseInt(bar.dataset.interval, 10) || 5000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      // sync arrow color to the active slide's text color
      bar.style.color = slides[index].style.color || '';
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    const nextBtn = bar.querySelector('[data-ann-next]');
    const prevBtn = bar.querySelector('[data-ann-prev]');
    if (nextBtn) nextBtn.addEventListener('click', () => { next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); start(); });

    // pause on hover
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);

    show(index);
    start();
  });

  /* ============================================================
     Slideshow carousel
  ============================================================ */
  document.querySelectorAll('[data-slideshow]').forEach(box => {
    const slides = Array.from(box.querySelectorAll('.slideshow__slide'));
    const dots = Array.from(box.querySelectorAll('[data-slide-dot]'));
    if (slides.length <= 1) return;

    let index = 0;
    let timer = null;
    const autoplay = box.dataset.autoplay === 'true';
    const interval = parseInt(box.dataset.interval, 10) || 5000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    const nextBtn = box.querySelector('[data-slide-next]');
    const prevBtn = box.querySelector('[data-slide-prev]');
    if (nextBtn) nextBtn.addEventListener('click', () => { next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); start(); });
    dots.forEach(d => d.addEventListener('click', () => { show(parseInt(d.dataset.slideDot, 10)); start(); }));

    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    start();
  });

  /* ============================================================
     Countdown timer
  ============================================================ */
  document.querySelectorAll('[data-countdown]').forEach(el => {
    const endStr = (el.dataset.end || '').replace(' ', 'T');
    const end = new Date(endStr).getTime();
    if (isNaN(end)) return;
    const expiredMsg = el.dataset.expired || 'This offer has ended.';
    const daysEl = el.querySelector('[data-days]');
    const hoursEl = el.querySelector('[data-hours]');
    const minsEl = el.querySelector('[data-mins]');
    const secsEl = el.querySelector('[data-secs]');
    const pad = n => String(n).padStart(2, '0');

    function tick() {
      const diff = end - Date.now();
      if (diff <= 0) {
        el.classList.add('countdown__timer--expired');
        el.innerHTML = expiredMsg;
        clearInterval(t);
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minsEl) minsEl.textContent = pad(m);
      if (secsEl) secsEl.textContent = pad(s);
    }
    tick();
    const t = setInterval(tick, 1000);
  });

  /* ============================================================
     Product page — sticky add-to-cart bar + share
  ============================================================ */
  (function pdpSticky() {
    const bar = document.getElementById('pdp-sticky');
    const form = document.getElementById('product-form');
    const anchor = document.querySelector('.product-info__actions');
    if (!bar || !form || !anchor) return;

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          // show the bar once the main buttons have scrolled above the viewport
          const above = e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', !e.isIntersecting && above);
        });
      }, { threshold: 0 });
      io.observe(anchor);
    }

    const addSticky = document.getElementById('sticky-add');
    if (addSticky) {
      addSticky.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    // keep sticky price in sync with the main price when a variant changes
    const priceEl = document.getElementById('product-price');
    const stickyPrice = document.getElementById('sticky-price');
    const picker = document.getElementById('variant-picker');
    if (picker && priceEl && stickyPrice) {
      picker.addEventListener('change', () => {
        setTimeout(() => { stickyPrice.textContent = priceEl.textContent.trim(); }, 0);
      });
    }
  })();

  /* Promotional popup + minimal sticky bar */
  document.querySelectorAll('[data-popup]').forEach(popup => {
    const id = popup.id;
    const designMode = window.Shopify && window.Shopify.designMode;
    const reappear = parseInt(popup.dataset.reappear, 10) || 0;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const minimalEnabled = isMobile ? popup.dataset.minimalMobile === 'true' : popup.dataset.minimalDesktop === 'true';
    const defaultStyle = isMobile ? popup.dataset.defaultMobile : popup.dataset.defaultDesktop;

    // Record that this visitor has closed the popup, so the "Reappear after N
    // days" rule can suppress it on future visits (stored per-device).
    function markSeen() { if (!designMode) { try { localStorage.setItem('wt-popup-' + id, Date.now().toString()); } catch (e) {} } }
    function openFull() { popup.classList.add('is-open'); popup.classList.remove('is-minimal'); popup.setAttribute('aria-hidden', 'false'); document.body.classList.add('popup-open'); }
    function showMinimal() { popup.classList.add('is-minimal'); popup.classList.remove('is-open'); popup.setAttribute('aria-hidden', 'false'); document.body.classList.remove('popup-open'); }
    function dismiss() {
      popup.classList.remove('is-open', 'is-minimal'); popup.setAttribute('aria-hidden', 'true'); document.body.classList.remove('popup-open');
      markSeen();
    }
    // Closing the full popup always counts as "seen" (starts the reappear timer),
    // even when it collapses to the minimal bar for the rest of this visit.
    function closeFull() { markSeen(); if (minimalEnabled) showMinimal(); else dismiss(); }
    function reveal() { if (defaultStyle === 'minimal' && minimalEnabled) showMinimal(); else openFull(); }

    popup.querySelectorAll('[data-popup-close]').forEach(el => el.addEventListener('click', closeFull));
    popup.querySelectorAll('[data-popup-open]').forEach(el => el.addEventListener('click', openFull));
    popup.querySelectorAll('[data-popup-dismiss]').forEach(el => el.addEventListener('click', dismiss));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && popup.classList.contains('is-open')) closeFull(); });

    // In the theme editor: show it so it can be edited, skip suppression/triggers
    if (designMode) { openFull(); return; }
    // If the email was just submitted, show the full popup with the success message
    if (popup.querySelector('.popup__success')) { openFull(); return; }

    if (reappear > 0) {
      try { const ts = parseInt(localStorage.getItem('wt-popup-' + id) || '0', 10); if (ts && (Date.now() - ts) / 86400000 < reappear) return; } catch (e) {}
    }
    if (isMobile && popup.dataset.showMobile !== 'true') return;

    const trigger = popup.dataset.trigger;
    if (trigger === 'load') {
      reveal();
    } else if (trigger === 'exit' && !isMobile) {
      const onExit = e => { if (e.clientY <= 0) { reveal(); document.removeEventListener('mouseout', onExit); } };
      document.addEventListener('mouseout', onExit);
    } else {
      setTimeout(reveal, parseInt(popup.dataset.delay, 10) || 5000);
    }
  });

  /* Click-to-copy coupon code */
  document.querySelectorAll('[data-copy-code]').forEach(btn => {
    btn.addEventListener('click', () => {
      const code = btn.dataset.copyCode;
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(code).then(() => {
        const c = btn.querySelector('.popup__coupon-copy');
        if (c) { const old = c.textContent; c.textContent = 'Copied!'; setTimeout(() => { c.textContent = old; }, 1500); }
      });
    });
  });

  /* Shop-by-brand chip carousel arrows */
  document.querySelectorAll('.brand-chips__viewport').forEach(vp => {
    const track = vp.querySelector('[data-chips-track]');
    if (!track) return;
    const prev = vp.querySelector('[data-chips-prev]');
    const next = vp.querySelector('[data-chips-next]');
    const amount = () => Math.max(track.clientWidth * 0.7, 200);
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
  });

  /* Hero slideshow (fade, autoplay, arrows, pager) */
  document.querySelectorAll('[data-hero-slideshow]').forEach(hero => {
    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const prevBtn = hero.querySelector('[data-hero-prev]');
    const nextBtn = hero.querySelector('[data-hero-next]');
    const interval = parseInt(hero.dataset.interval, 10) || 6000;
    const autoplay = hero.dataset.autoplay === 'true';
    let current = 0, timer = null;

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => {
        const active = idx === current;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === current));
    }
    function start() { if (autoplay) { stop(); timer = setInterval(() => go(current + 1), interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prevBtn) prevBtn.addEventListener('click', () => { go(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { go(current + 1); start(); });
    dots.forEach(d => d.addEventListener('click', () => { go(parseInt(d.dataset.heroDot, 10)); start(); }));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  });

  document.querySelectorAll('[data-copy-link]').forEach(btn => {
    btn.addEventListener('click', () => {
      const url = btn.dataset.copyLink;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          const old = btn.textContent;
          btn.textContent = '✓';
          setTimeout(() => { btn.textContent = old; }, 1200);
        });
      }
    });
  });

})();
